import { client } from "./client/client.gen";

export const IS_SERVER = typeof document === "undefined";

function getApiBaseUrl(): string {
    if (IS_SERVER) {
        return process.env.PIVO_API_URL ?? "http://localhost:5090";
    }
    if (window.location.hostname === "localhost") {
        return "https://localhost:7163"; // Development port
    }
    return window.location.origin;
}

export const PIVO_API_URL = getApiBaseUrl();

export const IS_LOCALHOST = PIVO_API_URL.includes("localhost");

if (IS_SERVER && process.env.NODE_ENV !== "production") {
    // In development the API may use a self-signed certificate (e.g. the
    // .NET dev HTTPS port); Node rejects those, which would break SSR data
    // loading in route loaders.
    process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
}

client.setConfig({
    baseURL: PIVO_API_URL,
});
